import { DatePipe, formatDate } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AccountPayoutCreation, AccountPayoutStatus, AccountPayoutType } from '../_enums/account';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { AccountService, AuthService, BackFilterService, ExcelDateConvertService } from '../_services';
import { AppConfig, ExcelService, PreviousRouteService } from '../_helpers/index';
import { AccountOperationPayoutList, AccountOperationPayoutListData, Payout, PayoutAmount } from '../_models';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';
import { CurrencyPipe } from '@angular/common';
import { Observable, Subject, forkJoin, of } from 'rxjs';
import { catchError, filter, map, takeUntil, tap } from 'rxjs/operators';


@Component({
  selector: 'accountoperationpayout',
  templateUrl: './accountoperationpayout.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class AccountOperationPayoutComponent implements OnInit, AfterViewInit {
  ddlAccountPayoutStatus: any[];
  ddlAccountPayoutCreation: any[];
  ddlAccountPayoutType: any[];
  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  isRangoVisiable = false;
  isRangoStatus = "None";
  filterValue;
  public customer_Account_public_id: string;
  public user_public_id: string;
  customer_public_id: string;

  dataSourceAccOperationPayoutList: MatTableDataSource<AccountOperationPayoutListData> = new MatTableDataSource();
  pageSize: number;
  pageIndex: number = 0;
  pageStart: number = 0;
  pageSizeOptions: number[];
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  isadmin = false;
  cust_account_name: any;
  displayedColumns: string[] = [];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  payoutCashInForm: FormGroup;
  tempAccount: any;
  userEmail: any;
  userId: any;
  isCashInAvailable = false;
  cancelPayoutId: any;

  startDate: string = "";
  endDate: string = "";
  totalSize: number = 0;
  private totalSizeRecords: number = 0;

  type: "ALL" | "CREDIT" | "DEBIT"  = "ALL";
  typeDropdownValue = 0;
  creationDropdownValue = 0;
  typeFormControl = new FormControl(0);
  creationFormControl = new FormControl(0);
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  searchValue = '';
  isDefaultVersion = true;

  private destroy$ = new Subject<void>();

  constructor(
    private _fb: FormBuilder,
    private accountPayoutCreation: AccountPayoutCreation,
    private accountPayoutStatus: AccountPayoutStatus,
    private accountPayoutType: AccountPayoutType,
    private datePipe: DatePipe,
    private router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private accountService: AccountService,
    private spinnerService: Ng4LoadingSpinnerService,
    private excelService: ExcelService,
    private currencyPipe: CurrencyPipe,
    private auth: AuthService,
    private backFilterService: BackFilterService,
    private previousRouteService: PreviousRouteService,
    private excelDateConvertService: ExcelDateConvertService
  ) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.pageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.backFilterService.getPayoutAccountSearchSharedData().subscribe(data => this.backToSearchSharedData = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
  }

  ngOnInit() {
    this.spinnerService.show();
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
        this.user_public_id = localStorage.getItem('userId');
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
      this.user_public_id = localStorage.getItem('userId');
    }
    this.userEmail = localStorage.getItem('userEmail');
    this.userId = localStorage.getItem('userId');

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }

    let params: any = this.activatedRoute.snapshot.params;
    this.customer_Account_public_id = params.id;
    this.checkThisPageGrants();
    this.ddlAccountPayoutCreation = this.accountPayoutCreation._creation;
    this.ddlAccountPayoutStatus = this.accountPayoutStatus._status;
    this.ddlAccountPayoutType = this.accountPayoutType._type;
    if (this.accountPayoutCreation._creation.length > 8) {
      this.accountPayoutCreation._creation.shift();
    }

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });
    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    this.previousUrl = this.previousRouteService.getPreviousUrl();
    if ((this.isBrowserBackButtonPressed == true) &&
      (this.previousUrl.includes("/payout_process/")) &&
      (this.previousUrl.includes("/view"))
    ) {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.setBackToSearchData();
    } else {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.backFilterService.setPayoutAccountSharedData(null);
    }

    this.searchFilterForm = this._fb.group({
      searchText: [this.searchValue, Validators.required]
    });
    // this.dataSourceAccOperationPayoutList.paginator = this.paginator;
    this.getConfigurations();
    this.GetAccountsDetails();
    this.getAccountOperationPayoutList(this.type, this.searchValue, this.startDate, this.endDate, this.pageSize, this.pageStart);
    this.InitialSetup();
  }

  setBackToSearchData() {
    if (this.backToSearchSharedData != null) {
      this.searchValue = this.backToSearchSharedData.search;
      this.typeFormControl.setValue(this.backToSearchSharedData.typeDropdownValue);
      this.creationFormControl.setValue(this.backToSearchSharedData.creationDropdownValue);
      this.typeDropdownValue = this.backToSearchSharedData.typeDropdownValue;
      this.creationDropdownValue = this.backToSearchSharedData.creationDropdownValue;
      this.type = this.backToSearchSharedData.type;
      this.pageSize = this.backToSearchSharedData.pageSize;
      this.pageIndex = this.backToSearchSharedData.pageIndex;
      this.pageStart = this.backToSearchSharedData.pageStart;
      this.paginator.pageIndex = this.pageIndex;

      if (this.backToSearchSharedData.creationDropdownValue == 8) {
        this.searchRangoFilterForm = this._fb.group({
          searchFromDate: [this.backToSearchSharedData.searchFromDate],
          searchToDate: [this.backToSearchSharedData.searchToDate]
        });
        this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
        this.ddlAccountPayoutCreation.unshift({ value: 8, name: this.filterValue });
        this.isRangoVisiable = false;
        this.startDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
        this.endDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));
        this.creationFormControl.setValue(8);
        this.creationDropdownValue = 8;
      } else {
        this.startDate = this.backToSearchSharedData.creationStartDate;
        this.endDate = this.backToSearchSharedData.creationEndDate;
      }
      this.setBackToSearchFilter();
    }
  }

  InitialSetup() {
    this.payoutCashInForm = this._fb.group({
      amount: new FormControl('', [Validators.required]),
    })

  }

  getAccountOperationPayoutListData(status: string, search: string, startDate: string, endDate: string, limit: number, start: number): Observable<AccountOperationPayoutList> {
    return this.accountService.getAccountOperationPayoutList(this.customer_Account_public_id, status, search, startDate, endDate, limit, start);
  }

  getAccountOperationPayoutList(status: string, search: string, startDate: string, endDate: string, limit: number, start: number) {
    this.spinnerService.show();

    this.getAccountOperationPayoutListData(status, search, startDate, endDate, limit, start)
      .pipe(
        takeUntil(this.destroy$),
        filter(data => data !== undefined && data.data !== undefined),
        tap(data => {
          this.dataSourceAccOperationPayoutList.data = data.data;
          this.totalSize = data.records;
          this.totalSizeRecords = this.totalSize;
          this.spinnerService.hide();
        }),
        catchError(error => {
          console.error('Failed! while trying to get Account Operation Payout List. ' + error.Error);
          this.spinnerService.hide();
          return of([]);
        })
      )
      .subscribe();
  }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit() {
    this.dataSourceAccOperationPayoutList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourceAccOperationPayoutList.sort = this.sort;
  }

  applyFilter() {
    this.searchValue = this.searchFilterForm.controls.searchText.value.trim().toLowerCase();
    this.pageStart = 0;
    this.paginator.pageIndex = 0;
    this.getAccountOperationPayoutList(this.type, this.searchValue, this.startDate, this.endDate, this.pageSize, this.pageStart);
    this.setBackToSearchFilter();
  }

  filterCreationDetails(creation) {
    this.creationDropdownValue = creation;
    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);

    // All Datas Condition
    if (creation == 0) {
      this.startDate = "";
      this.endDate = "";
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.startDate = this.convertGMTTime(new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.startDate = this.convertGMTTime(new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
    }

    // Today Filter Condition
    if (creation == 3) {
      currentDate.setDate(currentDate.getDate());
      this.startDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      currentDate.setDate(currentDate.getDate() - 1);
      this.startDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
    }

    // Last Week Filter Condition
    if (creation == 5) {
      this.startDate = this.convertGMTTime(new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.startDate = this.convertGMTTime(new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
    }

    // Range Filter Condition
    if (creation == 7) {
      this.startDate = "";
      this.endDate = "";
      this.isRangoVisiable = true;
    } else {
      this.isRangoVisiable = false;
    }

    if (creation == 8) {
      this.startDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.endDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));
    }

    this.pageStart = 0;
    this.paginator.pageIndex = 0;
    this.getAccountOperationPayoutList(this.type, this.searchValue, this.startDate, this.endDate, this.pageSize, this.pageStart);
    this.setBackToSearchFilter();
  }

  pageEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getAccountOperationPayoutList(this.type, this.searchValue, this.startDate, this.endDate, this.pageSize, this.pageStart);
    this.setBackToSearchFilter();
  }

  filterTypeDetails(type) {
    this.typeDropdownValue = type;

    if (type == this.ddlAccountPayoutType[0].value) {
      this.type = "ALL"
    } else if (type == this.ddlAccountPayoutType[1].value) {
      this.type = 'CREDIT';
    } else if (type == this.ddlAccountPayoutType[2].value) {
      this.type = 'DEBIT';
    }

    this.pageStart = 0;
    this.paginator.pageIndex = 0;
    this.getAccountOperationPayoutList(this.type, this.searchValue, this.startDate, this.endDate, this.pageSize, this.pageStart);
    this.setBackToSearchFilter();
  }

  filterAllDetails() {
    if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
      && this.searchRangoFilterForm.controls.searchFromDate.value !== '' && this.searchRangoFilterForm.controls.searchToDate.value !== ''
    ) {
      this.filterRangoDetails();
    }
    else {
      this.isRangoVisiable = false;
      this.creationFormControl.setValue(0);
      this.creationDropdownValue = 0;
      this.startDate = "";
      this.endDate = "";
    }
    this.setBackToSearchFilter();
  }

  filterRangoDetails() {

    if (this.accountPayoutCreation._creation.length > 8) {
      this.accountPayoutCreation._creation.shift();
    }

    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
    this.ddlAccountPayoutCreation.unshift({ value: 8, name: this.filterValue });
    this.isRangoVisiable = false;

    this.startDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
    this.endDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));

    this.creationFormControl.setValue(8);
    this.creationDropdownValue = 8;
    this.pageStart = 0;
    this.paginator.pageIndex = 0;
    this.getAccountOperationPayoutList(this.type, this.searchValue, this.startDate, this.endDate, this.pageSize, this.pageStart);
    this.setBackToSearchFilter();
  }

  GetAccountsDetails() {
    this.accountService.getAccount(this.customer_Account_public_id).subscribe(data => {
      this.tempAccount = data;
      this.cust_account_name = data.name;
    },
      error => {
        console.error('Failed! while trying to get the acccount details list. ' + error.error);
      });
  }

  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }

  exportAsXLSX() {
    this.spinnerService.show();
    const pageStart = 0;
    this.getAccountOperationPayoutListData(this.type, this.searchValue, this.startDate, this.endDate, this.totalSizeRecords, pageStart)
      .pipe(
        filter(data => data !== undefined && data.data !== undefined),
        tap(data => {
          this.setExportExcelFileData(data.data);
          this.spinnerService.hide();
        }),
        catchError(error => {
          console.error('Failed! while trying to get Account Operation Payout List. ' + error.Error);
          this.spinnerService.hide();
          return of(null);
        })
      ).subscribe();
  }

  setExportExcelFileData(excelExportData: AccountOperationPayoutListData[]) {
    var excelHeader;
    if (this.isDefaultVersion == false) {
      excelHeader = ["FECHA DE OPERACIÓN", "DESCRIPCIÓN", "TRANSACCIÓN", "CRÉDITO", "DÉBITO", "BALANCE", "REFERENCIA"]
    } else {
      excelHeader = ["FECHA DE OPERACIÓN", "DESCRIPCIÓN", "CRÉDITO", "DÉBITO", "BALANCE", "REFERENCIA", "TIPO"]
    }
    var arrFinalData = [];
    var object_temp = {};
    var i = 0;
    var columnsKeyNames = [];
    for (i = 0; i < excelExportData.length; i++) {
      var singleRec_temp = excelExportData[i];
      columnsKeyNames = Object.keys(singleRec_temp);
      var created_temp;
      var desc_temp = "";
      var credit_temp = "";
      var debit_temp = "";
      var balance_temp = "";
      var reference_temp = "";
      var type_temp = "";
      object_temp = {};
      for (var j = 0; j < columnsKeyNames.length; j++) {
        if (columnsKeyNames[j] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[j]];
        }

        if (columnsKeyNames[j] == "transaction") {
          if (this.isDefaultVersion == true) {
            if (singleRec_temp[columnsKeyNames[j]].type == 'PAYOUT') {
              type_temp = 'Pago';
            }
            else if (singleRec_temp[columnsKeyNames[j]].type == 'DEPOSIT') {
              type_temp = 'Depósito';
            }
            else if (singleRec_temp[columnsKeyNames[j]].type == 'WITHDRAWAL') {
              type_temp = 'Ajuste';
            }
            else {
              type_temp = singleRec_temp[columnsKeyNames[j]].type;
            }
          }
          if (this.isDefaultVersion == false) {
            if (singleRec_temp[columnsKeyNames[j]] != undefined) {
              if (singleRec_temp[columnsKeyNames[j]].metadata != undefined) {
                type_temp = singleRec_temp[columnsKeyNames[j]].metadata.name;
              }
            }
          }

          if (singleRec_temp[columnsKeyNames[j]] != undefined) {
            if (singleRec_temp[columnsKeyNames[j]].metadata != undefined) {
              desc_temp = singleRec_temp[columnsKeyNames[j]].metadata.description;
            }
          }
        }

        if (columnsKeyNames[j] == "type") {
          if (singleRec_temp[columnsKeyNames[j]] == 'CREDIT') {
            //credit_temp = this.currencyPipe.transform(singleRec_temp['transaction'].total.value,singleRec_temp['transaction'].total.symbol);
            credit_temp = this.currencyPipe.transform(singleRec_temp['transaction'].total.value, "", "");
          }
          else {
            credit_temp = '';
          }
        }

        if (columnsKeyNames[j] == "type") {
          if (singleRec_temp[columnsKeyNames[j]] == 'DEBIT') {
            //debit_temp = this.currencyPipe.transform(singleRec_temp['transaction'].total.value,singleRec_temp['transaction'].total.symbol);
            debit_temp = this.currencyPipe.transform(singleRec_temp['transaction'].total.value, "", "");
          }
          else {
            debit_temp = '';
          }
        }
        if (columnsKeyNames[j] == "new_balance") {
          //balance_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[j]].value,singleRec_temp[columnsKeyNames[j]].symbol);
          balance_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[j]].value, "", "");
        }
        if (columnsKeyNames[j] == "reference") {
          reference_temp = singleRec_temp[columnsKeyNames[j]];
        }


      }
      if (this.isDefaultVersion == true) {
        arrFinalData.push([this.excelDateConvertService.convertExcelDateTime(created_temp), desc_temp, credit_temp, debit_temp, balance_temp, reference_temp, type_temp]);
      }

      if (this.isDefaultVersion == false) {
        arrFinalData.push([this.excelDateConvertService.convertExcelDateTime(created_temp), desc_temp, type_temp, credit_temp, debit_temp, balance_temp, reference_temp]);
      }
    }
    this.excelService.generateAccountOperationPayoutExcelFile(excelHeader, arrFinalData, 'AccountOperationPayout');
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      if (!((charCode >= 37 && charCode <= 42) || charCode == 45 || charCode == 46 || charCode == 35 || charCode == 32)) {
        return false;
      }
    }
    return true;
  }

  send({ value }: { value: PayoutAmount }) {
    let body = {
      "user": { "public_id": this.userId },
      "account": { "public_id": this.customer_Account_public_id },
      "amount": value.amount
    }
    this.accountService.cashIn(body).subscribe(data => {
      console.log(data)
    }, error => {
      console.error('Failed!' + error.error);
    })
  }

  async checkThisPageGrants() {
    await this.auth.isKashioGrantsAvailable();
    this.isCashInAvailable = this.auth.checkGrants('ACCOUNTS', 'CASH-IN');
  }

  setBackToSearchFilter() {
    this.tempSearch = {
      search: this.searchValue,
      creationStartDate: this.startDate,
      creationEndDate: this.endDate,
      typeDropdownValue: this.typeDropdownValue,
      creationDropdownValue: this.creationDropdownValue,
      searchFromDate: this.searchRangoFilterForm.controls.searchFromDate.value,
      searchToDate: this.searchRangoFilterForm.controls.searchToDate.value,
      type: this.type,
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setPayoutAccountSharedData(this.tempSearch);
  }

  async getConfigurations() {
    try {
      const data = await this.accountService.getPayoutAccountConfigurationsDetails(this.customer_public_id);
      //Configurated version
      this.isDefaultVersion = false;
      this.displayedColumns = ['created', 'description', 'transaction.metadata.name', 'transaction.total.value', 'debit', 'new_balance.value', 'reference']
    } catch (error) {
      if (error.status == 404) {
        //Default version
        this.isDefaultVersion = true;
        this.displayedColumns = ['created', 'description', 'transaction.total.value', 'debit', 'new_balance.value', 'reference']
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
